<template>
  <section class="container-fluid my-4">
    <h4 class="my-4">Cadastro de <strong>Usuários</strong></h4>

    <form @submit.prevent="handlerSubmit">
      <div class="row">

        <div class="form-group col-md-12">
          <label for="name">Nome</label>
          <input type="text" class="form-control" id="name" v-model="item.name" />
        </div>

        <div class="form-group col-md-12">
          <label for="email">E-mail/Usuário</label>
          <input type="email" class="form-control" id="email" v-model="item.email"/>
        </div>

        <div class="form-group col-md-12 mt-2">
          <label for="password">Senha</label>
          <input type="password" class="form-control" id="password" v-model="item.password" />
        </div>

        <div v-if="isAdmin" class="form-group col-md-12 mt-2">
          <label for="role">Perfil</label>
          <select id="role" class="form-control" v-model="item.role">
            <option v-for="option in userRoleOptions" :key="option.id" :value="option.id">
              {{ option.name }}
            </option>
          </select>
        </div>

      </div>

      <div class="form-group text-center my-2">
        <button type="submit" class="btn btn-success btn-sm mx-2">
          SALVAR
        </button>
        <button type="reset" class="btn btn-secondary btn-sm">LIMPAR</button>
      </div>
    </form>
    <button class="btn btn-sm btn-secondary" @click="$router.go(-1)">
      VOLTAR
    </button>
  </section>
</template>
      
<script>
import api from "@/services";
import { errorsToString, userRoleOptions } from "@/helpers";

export default {
  name: "UserRegister",
  data() {
    return {
      userRoleOptions,
      isAdmin: false,
      item: {
        role: "comercial",
      },
    };
  },
  methods: {
    async loadRole() {
      try {
        const { data } = await api.post("/auth/me");
        this.isAdmin = data.role === "admin";
        if (data.role) window.localStorage.role = data.role;
      } catch (error) {
        this.isAdmin = window.localStorage.role === "admin";
      }
    },
    async handlerSubmit() {
      try {
        const { data } = await api.post(`/users`, this.item);
        Toast.fire(data.message, "", "success");
        this.$router.push({ name: "users" });
      } catch (error) {
        Toast.fire(errorsToString(error.response.data.errors), "", "error");
      }
    },
  },
  mounted() {
    this.loadRole();
  },
};
</script>
      
<style scoped></style>